import React from "react";
import { toast } from "react-toastify";
import { setIsLoggedIn, setRole } from "../slices/app";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
const SuperLoggedInUserPopup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    // localStorage.removeItem("name");
    // localStorage.removeItem("accessToken");
    // localStorage.removeItem("refreshToken");
    // localStorage.removeItem("tokenExpiresIn");
    // localStorage.removeItem("role");
    // localStorage.removeItem("baseCurrency");
    // localStorage.removeItem("id");
    // localStorage.removeItem("email");
    localStorage.clear();
    toast.success("Logged out successfully!");
    dispatch(setIsLoggedIn(false));
    dispatch(setRole(""));
    setTimeout(() => {
      navigate("/", { replace: true });
    }, 1000);
  };

  return (
    <div className="w-52 bg-white">
      <div
        className="text-[#EB4143] text-center cursor-pointer"
        onClick={handleLogout}
      >
        <i className="fa-solid fa-arrow-right-from-bracket me-2"></i>Logout
      </div>
    </div>
  );
};

export default SuperLoggedInUserPopup;
